
<template>

	<mymodal ref="modal" :title="essence + '. Множественное редактирование. Ценообразующие факторы'" ok="Применить" :reset="reset" :check="check" :submit="submit">

		<attr_select_and_set_value v-model="attr_and_value" :service="$parent.service" :attrs="attrs" ref="attr_select_and_set_value" new_modal without_system without_bad/>

	</mymodal>

</template>

<script>

import api from "../../../../api"
import mymodal from "../../../widgets/modal"
import attr_select_and_set_value from "../../../widgets/attr_select_and_set_value"

export default
{
	props :
	{
		essence : String,
	},

	components:
	{
		mymodal,
		attr_select_and_set_value,
	},

	data()
	{
		return {
			
			attrs : [],
			attr_and_value : {},

		}
	},

	methods :
	{
		check()
		{
			if(this.$refs.attr_select_and_set_value == null)
				return false

			const attr_select_and_set_value_state = this.$refs.attr_select_and_set_value.check()
			const value_state = this.attr_and_value.value != null

			return attr_select_and_set_value_state && value_state
		},

		reset()
		{
			this.attr_and_value = {}
		},

		execute()
		{
			this.attrs = this.$parent.attrs.filter(attr => attr.status != "system")

			this.$refs.modal.execute()
		},

		submit()
		{
			const params = {
			
				field : this.attr_and_value.key,
				value : this.attr_and_value.value,
				query : this.$parent.get_query(),

			}

			api.call_long_operation(this, this.essence + " / Множественное редактирование / Ценообразующие факторы", this.$parent.service, "set_field_in_current_version_many", params,
				response =>
				{
					this.$parent.refresh_objects()
					api.open_response_url(response)
				})
		},
	}
}

</script>

